<template>
    <div class="MainContainer">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "MainContainer"
    }
</script>
